<div class="unauthorized-container" *transloco="let t">
  <div class="unauthorized-content">
    <mat-icon class="unauthorized-icon">lock</mat-icon>
    <h1 class="unauthorized-title">{{ t('unauthorized.title') }}</h1>
    <p class="unauthorized-message">{{ t('unauthorized.message') }}</p>
  </div>
</div>
